export default __webpack_public_path__ + "static/sam42_it-77ec4810ab42cf7c0a085c830f74d9d4.jpg";